import BlockIcon from '@mui/icons-material/Block'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import {
  LICENSE_STATUSES,
  LicenseRow
} from '@/views/Operators/Operator/Licenses/licenses.dge.table'

import { ActionMenuDialogItem } from '../ActionMenuDialogItem/ActionMenuDialogItem'
import { useActionMenuContext } from '../context/ActionMenuContext'

interface ActionToggleOperatorLicenseDeactivateItemProps {
  onClick: (row: LicenseRow) => Promise<void> | void
  displaySeparately?: boolean
}

export const ActionToggleOperatorLicenseDeactivateItem = ({
  onClick,
  displaySeparately = false
}: ActionToggleOperatorLicenseDeactivateItemProps) => {
  const { row } = useActionMenuContext<LicenseRow>()
  const isDeactivated = row.status.type === LICENSE_STATUSES.DEACTIVATED

  return (
    <ActionMenuDialogItem
      displaySeparately={displaySeparately}
      onClick={onClick}
      successMessage={`License ${row.id} ${isDeactivated ? 'enabled' : 'deactivated'} successfully`}
      errorMessage={`Failed to ${isDeactivated ? 'enable' : 'deactivate'} license ${row.id}`}
      confirmationMessage={`Are you sure you want to ${isDeactivated ? 'enable' : 'deactivate'} the license ${row.id}?`}
      label={isDeactivated ? 'Enable' : 'Deactivate'}
      overrideText={isDeactivated ? 'Enable License' : 'Deactivate License'}
      icon={isDeactivated ? <CheckCircleIcon /> : <BlockIcon />}
    />
  )
}
